import { getAuth, onAuthStateChanged } from "firebase/auth"
import { addListnerForAuthStateVisibility, handleSignOut, initFirebase } from "./utils/fbase"
import { formatterCurrency, removeAllChildNodes } from "./utils/helper-functions"
import addNavbarBurgerListner from "./utils/navbar-burger"
import { doc, getDoc, getFirestore, increment, setDoc, updateDoc } from "firebase/firestore"
import Fuse from 'fuse.js'
import { handleCart } from "./utils/navbar-cart"
import { toast } from "bulma-toast"

initFirebase()

const productsPerPage = 20

let productsAll = {}
let productsToDisplay = []
let pageNo = 1
let pageCount = 1
let searchEngine = null

function refreshProductsDisplay(isLoadMore = false) {
    if (pageNo < 1) {
        pageNo = 1
        return;
    }
    if (pageNo > pageCount) {
        pageNo = pageCount
        return;
    }
    let indexStart = (pageNo - 1) * 20
    let indexEnd = indexStart + productsPerPage

    if (productsToDisplay && indexEnd > productsToDisplay.length) indexEnd = productsToDisplay.length

    const products_container = document.getElementById('products_container')
    removeAllChildNodes(products_container)
    // if(!removeAllChildNodes(products_container)) removeAllChildNodes(products_container)

    const pagination_info = document.getElementById('pagination_info')
    pagination_info.innerText = `Page ${pageNo} of ${pageCount}`

    if (productsToDisplay.length) {
        for (let i = indexStart; i < indexEnd; i++) {
            const el = document.createElement('div')
            el.classList.add("column", "is-one-quarter-widescreen", "is-one-third-desktop", "is-half-tablet")
            el.innerHTML = `
                            <div class="card">
                                <div class="card-image">
                                    <figure class="image is-square is-contain">
                                        <img src='${productsToDisplay[i].images[0]}' alt="${productsToDisplay[i].name}" width="600" height="600">
                                    </figure>
                                    <span class="card-header-icon has-cursor-default py-0"><strong
                                        class="has-text-primary has-animation-blink"> ${productsToDisplay[i].specialText}</strong></span>
                                </div>
                                <div class="card-content pt-1">
                                    <p class="has-text-centered">${productsToDisplay[i].name}</p>
                                    <div class="columns is-multiline mt-2">
                                        <span class="column is-half py-0">SKU: ${productsToDisplay[i].sku}</span>
                                        <span class="column is-half py-0">MOQ: ${productsToDisplay[i].moq || ''}</span>
                                        <span class="column is-half py-0">COST: ${productsToDisplay[i].price ? formatterCurrency.format(productsToDisplay[i].price) : ''}</span>
                                        <span class="column is-half py-0">RETAIL: ${productsToDisplay[i].retail ? formatterCurrency.format(productsToDisplay[i].retail) : ''}</span>
                                    </div>
                                </div>
                                <div class="card-footer is-flex-direction-column">
                                    <button class="card-footer-item button is-text is-fullwidth" data-product-add-to-cart="${productsToDisplay[i].key}" type="button">Add to cart</button>
                                </div>
                            </div>
                            `
            products_container.appendChild(el)
        }
    }
    else {
        const el = document.createElement('p')
        el.classList.add("is-size-4", "has-text-centered")
        el.innerText = "No products were found matching your selection."
        products_container.appendChild(el)
    }
}

function handleSearch() {
    const search_result = document.getElementById('search_result')
    const search_result_message = document.getElementById('search_result_message')
    const urlSearchParams = new URLSearchParams(location.search)
    if (searchEngine !== null && urlSearchParams.has('search') && urlSearchParams.get('search') !== '') {
        const query = decodeURIComponent(urlSearchParams.get('search'))
        search_result_message.innerText = query
        productsToDisplay = searchEngine.search(query).map(obj => obj.item)
        search_result.classList.remove('is-hidden')
    }
    else {
        search_result.classList.add('is-hidden')
        search_result_message.innerText = ''
        productsToDisplay = []
        Object.keys(productsAll).forEach(key => {
            if (productsAll[key].status !== 'I') productsToDisplay.push(productsAll[key])
        })
    }
    pageNo = 1
    pageCount = Math.ceil(productsToDisplay.length / productsPerPage) || 1
    refreshProductsDisplay()
}

window.addEventListener('popstate', () => {
    handleSearch()
})

document.addEventListener('DOMContentLoaded', () => {
    console.log("DOMContentLoaded")
    console.log(process.env.FBASE_APP_ID)

    addNavbarBurgerListner()
    addListnerForAuthStateVisibility()
    handleCart()

    try {
        const btn_signout_el = document.getElementById('btn_signout')
        btn_signout_el.addEventListener('click', () => {
            btn_signout_el.classList.add('is-loading')
            handleSignOut()
            btn_signout_el.classList.remove('is-loading')
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #btn_signout.", error)
    }

    try {
        const products_container = document.getElementById('products_container')
        products_container.addEventListener('click', (event) => {
            const el = event.target
            if ('productAddToCart' in el.dataset) {
                el.classList.add('is-loading')
                const productKey = el.dataset.productAddToCart
                const user = getAuth().currentUser
                if (user) {
                    if (productKey && productsAll.hasOwnProperty(productKey)) {
                        const cartDocRef = doc(getFirestore(), "carts", user.uid, "user_cart", user.uid)
                        setDoc(cartDocRef, {
                            lines: {
                                [productKey]: {
                                    key: productKey,
                                    sku: productsAll[productKey].sku,
                                    name: productsAll[productKey].name,
                                    qtyOrdered: increment(productsAll[productKey].moq || 1),
                                    price: productsAll[productKey].price
                                }
                            }
                        }, { merge: true })
                        toast({
                            type: 'is-success',
                            dismissible: true,
                            position: 'top-center',
                            message: `Added ${productsAll[productKey].moq || 1} x ${productsAll[productKey].sku}`
                        })
                    }
                    else {
                        alert("Error: Invalid product key.")
                    }
                }
                else {
                    alert("Please, sign in first.")
                }



                el.classList.remove('is-loading')
            }
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #product_container.", error)
    }

    try {
        const search_form = document.getElementById('search_form')
        search_form.addEventListener('submit', (event) => {
            event.preventDefault()
            const form = event.target

            const btn_submit = form['btn_submit']
            btn_submit.classList.add('is-loading')

            const search_input = form['search_input'].value

            if (history.pushState) {
                const url = new URL(window.location.href);
                url.searchParams.set('search', search_input);
                history.pushState({}, '', encodeURI(url.toString()))
                handleSearch()
            }
            btn_submit.classList.remove('is-loading')
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #search_form.", error)
    }

    try {
        const btn_clear_search = document.getElementById('btn_clear_search')
        const search_input = document.getElementById('search_input')
        btn_clear_search.addEventListener('click', (event) => {
            event.preventDefault()

            btn_clear_search.classList.add('is-loading')

            if (history.pushState) {
                const url = new URL(window.location.href);
                url.searchParams.delete('search')
                history.pushState({}, '', encodeURI(url.toString()))
                handleSearch()
            }
            else {
                const url = new URL(window.location.href);
                url.searchParams.delete('search')
                location = encodeURI(url.toString())
            }
            search_input.value = ''
            btn_clear_search.classList.remove('is-loading')
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #btn_clear_search.", error)
    }

    try {
        const pagination_container = document.getElementById('pagination_container')
        pagination_container.addEventListener('click', (event) => {
            const target = event.target
            console.log(target.dataset)

            if (target.dataset.hasOwnProperty('pageNext')) {
                pageNo++
                target.classList.add('is-loading')
                refreshProductsDisplay()
                target.classList.remove('is-loading')
            }
            else if (target.dataset.hasOwnProperty('pagePrevious')) {
                pageNo--
                target.classList.add('is-loading')
                refreshProductsDisplay()
                target.classList.remove('is-loading')
            }
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #pagination_container.", error)
    }

    const auth = getAuth()
    onAuthStateChanged(auth, (user) => {
        const url = "https://static.nearlyfamous.ca/" + process.env.FBASE_APP_ID + "/products.json"
        fetch(url, {
            cache: "no-cache"
        })
            .then(res => res.json())
            .then(productsDataPublic => {
                if (typeof productsDataPublic === 'object' && !Array.isArray(productsDataPublic)) {
                    productsAll = Object.fromEntries(Object.entries(productsDataPublic).sort(([, a], [, b]) => b.position - a.position))
                }
                else productsAll = {}

            })
            .then(() => {
                if (!user || !Object.keys(productsAll).length) return null
                const docRef = doc(getFirestore(), process.env.FBASE_APP_ID, "products")
                return getDoc(docRef)
            })
            .then(docSnapshot => {
                if (!docSnapshot || !Object.keys(productsAll).length) return {}
                const data = docSnapshot.data()

                return JSON.parse(data.json)
            })
            .then(productDataProtected => {
                productsToDisplay = []

                if (Object.keys(productDataProtected).length) {
                    Object.keys(productsAll).forEach(key => {
                        if (productDataProtected.hasOwnProperty(key)) {
                            const data = {
                                ...productsAll[key],
                                ...productDataProtected[key]
                            }
                            productsAll[key] = data
                            if (productsAll[key].status !== 'I') productsToDisplay.push(data)
                        }
                    })
                }
                else {
                    Object.keys(productsAll).forEach(key => {
                        const data = {
                            ...productsAll[key]
                        }

                        if (productsAll[key].status !== 'I') productsToDisplay.push(data)
                    })
                }
                const list = productsToDisplay.map(item => item)
                searchEngine = new Fuse(list, {
                    findAllMatches: true,

                    keys: [
                        'name',
                        'tags'
                    ]
                })
                handleSearch()
            })
            .catch(error => {
                console.log(error)
                productsAll = {}
            })
    })

})